import React from 'react'

const OperationalModule = () => {
  return (
    <div>OperationalModule</div>
  )
}

export default OperationalModule